module.exports = __webpack_public_path__ + "d91f72c4423d3c69cf091ddee5db01d0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/3_D2.mp3
// module id = 60
// module chunks = 0